export default __webpack_public_path__ + "img/40b28e968147ccdb54848a6d924d9471.svg";